import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchBasicAutomationsRequest = createAction("workflowBasicAutomations/fetchRequest");
export const saveBasicAutomationsRequest = createAction("workflowBasicAutomations/saveRequest");

const initialState = {
  rules: null,
  loading: false,
  error: null,
  saveLoading: false,
  saveError: null,
  saveSuccess: false
};

const basicAutomationsSlice = createSlice({
  name: "workflowBasicAutomations",
  initialState,
  reducers: {
    fetchBasicAutomationsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBasicAutomationsSuccess(state, action) {
      state.loading = false;
      state.rules = action.payload;
      state.error = null;
    },
    fetchBasicAutomationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    saveBasicAutomationsStart(state) {
      state.saveLoading = true;
      state.saveError = null;
      state.saveSuccess = false;
    },
    saveBasicAutomationsSuccess(state) {
      state.saveLoading = false;
      state.saveError = null;
      state.saveSuccess = true;
    },
    saveBasicAutomationsFailure(state, action) {
      state.saveLoading = false;
      state.saveError = action.payload;
      state.saveSuccess = false;
    },
    clearBasicAutomationsSaveState(state) {
      state.saveLoading = false;
      state.saveError = null;
      state.saveSuccess = false;
    }
  }
});

export const {
  fetchBasicAutomationsStart,
  fetchBasicAutomationsSuccess,
  fetchBasicAutomationsFailure,
  saveBasicAutomationsStart,
  saveBasicAutomationsSuccess,
  saveBasicAutomationsFailure,
  clearBasicAutomationsSaveState
} = basicAutomationsSlice.actions;

export default basicAutomationsSlice.reducer;
